export default __webpack_public_path__ + "static/media/kael.b23c4f82.jpg";